function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "back",
  stroke: "#625AFF"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  strokeWidth: 1.728,
  fill: "#FFFFFF",
  x: 0.864,
  y: 0.864,
  width: 32.272,
  height: 32.272,
  rx: 16.136
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.5576554,17.5476454 C20.6161221,17.4973834 20.65,17.4249002 20.65,17.3492427 C20.65,17.2735851 20.6161221,17.201102 20.5576554,17.1508399 L13.4542215,11.0664896 C13.341113,10.9696691 13.1689913,10.9797215 13.0684504,11.0892398 C12.9690023,11.1976999 12.9788378,11.3659454 13.0919464,11.462766 L19.9647918,17.3492427 L13.0924928,23.2351903 C12.9793843,23.3320108 12.9690023,23.4997272 13.0689968,23.6087165 C13.1689913,23.7182348 13.3416594,23.7288163 13.4547679,23.6314666 L20.5576554,17.5476454 Z",
  id: "Shape-Copy-2",
  strokeWidth: 1.44,
  fill: "#625AFF",
  transform: "translate(16.825000, 17.349085) rotate(-180.000000) translate(-16.825000, -17.349085) "
})));

var SvgBack = function SvgBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back.3582b7ae.svg";
export { ForwardRef as ReactComponent };